<h1 mat-dialog-title>{{ 'CHARGE_INVOICE_DIALOG.TITLE' | translate : { number: invoiceNumber } }}</h1>
<form (ngSubmit)="onSave()" [formGroup]="formGroup">
  <mat-dialog-content class="charge-invoice-form">
    <div class="display-amounts">
      <p>
        {{ 'CHARGE_INVOICE_DIALOG.TOTAL' | translate }}
        <strong>
          {{ totalAmount / 100 | currency : invoiceCurrency : 'symbol' : '1.2-2' }}
        </strong>
      </p>
      <p>
        {{ 'CHARGE_INVOICE_DIALOG.OUTSTANDING' | translate }}
        <strong>
          {{ outstandingBalance / 100 | currency : invoiceCurrency : 'symbol' : '1.2-2' }}
        </strong>
      </p>
    </div>
    <!-- Amount -->
    <glxy-form-field class="full-width-field" prefixText="$">
      <glxy-label>{{ 'CHARGE_INVOICE_DIALOG.AMOUNT' | translate }}</glxy-label>
      <input matInput formControlName="amount" required />
      <glxy-error *ngIf="formGroup.get('amount').hasError('required')">
        {{ 'CHARGE_INVOICE_DIALOG.ERROR_AMOUNT_IS_REQUIRED' | translate }}
      </glxy-error>
      <glxy-error *ngIf="formGroup.get('amount').getError('min')">
        {{ 'CHARGE_INVOICE_DIALOG.ERROR_MINIMUM_AMOUNT' | translate }}&cent;
      </glxy-error>
    </glxy-form-field>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" align="end">
    <button mat-button mat-dialog-close>{{ 'CHARGE_INVOICE_DIALOG.CANCEL' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="formGroup.invalid || (loading$$ | async)">
      <div class="loading-button">
        <ng-container *ngIf="(loading$$ | async) === false">
          <mat-icon icon>attach_money</mat-icon>
        </ng-container>
        <mat-progress-spinner *ngIf="loading$$ | async" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
        <span>{{ 'CHARGE_INVOICE_DIALOG.CHARGE' | translate }}</span>
      </div>
    </button>
  </mat-dialog-actions>
</form>
